import { IpBlocklistService } from "@/common/api.service";
import {
  GET_IP_BLOCKLIST,
  POST_IP_BLOCKLIST,
  GET_IP_BLOCKLIST_DETAILS,
  UPDATE_IP_BLOCKLIST,
  DELETE_IP_BLOCKLIST,
} from "./actions.type";
import { SET_ERROR, ISLOADING } from "./mutations.type";

const state = {
  errors: null,
  ip_blocklist: {},
};

const getters = {
  ip_blocklist(state) {
    return state.ip_blocklist;
  },
};

const actions = {
  // Get IP blocklist
  async [GET_IP_BLOCKLIST](context, payload) {
    IpBlocklistService.init();
    IpBlocklistService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      IpBlocklistService.get(`ipblocklist/list${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          context.commit("setIpBlocklist", data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },

  // Store IP
  async [POST_IP_BLOCKLIST](context, payload) {
    IpBlocklistService.init();
    IpBlocklistService.setHeader();
    return new Promise((resolve) => {
      IpBlocklistService.post(`ipblocklist/store`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Get IP details
  async [GET_IP_BLOCKLIST_DETAILS](context, payload) {
    IpBlocklistService.init();
    IpBlocklistService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      IpBlocklistService.get(`ipblocklist/detail/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },

  // Update IP
  async [UPDATE_IP_BLOCKLIST](context, payload) {
    IpBlocklistService.init();
    IpBlocklistService.setHeader();
    return new Promise((resolve) => {
      IpBlocklistService.put(`ipblocklist/update/${payload.id}`, payload)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          resolve(response);
        });
    });
  },

  // Delete IP
  async [DELETE_IP_BLOCKLIST](context, payload) {
    IpBlocklistService.init();
    IpBlocklistService.setHeader();
    context.commit(ISLOADING, true);
    return new Promise((resolve) => {
      IpBlocklistService.put(`ipblocklist/delete/${payload}`)
        .then((data) => {
          context.commit(ISLOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(ISLOADING, false);
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
  setIpBlocklist(state, data) {
    state.ip_blocklist = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
